<template>
    <DForm
        @submit.prevent="submitForm"
    >
        <DFormRow
            :label="__('tools.testing.tenant.form.name')"
            :is-required="true"
        >
            <DInput
                id="name"
                v-model="form.name"
                :placeholder="__('tools.testing.tenant.form.name')"
                add-input-classes="bg-light"
                :is-valid="isFormFieldValid('name')"
                maxlength="255"
            />
            <p
                v-if="errors.name"
                class="m-0 pt-1 text-danger"
            >
                {{ errors.name[0] }}
            </p>
        </DFormRow>
        <DFormControls
            :dirty="form.isDirty"
            @submit="submitForm"
        />
    </DForm>
</template>

<script>
export default {
    name: 'TenantsForm',
    props: {
        errors: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    emits: ['form-submitted'],
    data () {
        return {
            form: this.$inertia.form({
                copy_from_tenant: null,
                name: null
            })
        }
    },
    methods: {
        submitForm () {
            this.$emit('form-submitted', this.form)
        }
    }
}
</script>
